
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Building2, Truck, Zap } from 'lucide-react';

const ChicagoPage = () => {
  return (
    <CityPageTemplate
      city="Chicago"
      state="Illinois"
      stateAbbr="IL"
      population="2.7 million+"
      majorIndustries={["manufacturing", "transportation", "finance", "technology", "healthcare"]}
      businessChallenges={[
        "Manufacturing workforce safety and compliance",
        "Transportation industry DOT regulations",
        "Harsh winter weather business disruptions",
        "Union-heavy workforce management",
        "High workers' compensation costs"
      ]}
      peoSolutions={[
        "Manufacturing safety programs and compliance support",
        "Transportation industry specialized HR services",
        "Weather-related business continuity planning",
        "Union relations and collective bargaining support",
        "Workers' compensation cost management programs"
      ]}
      localBusinessTypes={[
        { name: "Manufacturing", description: "Industrial equipment, food processing, steel" },
        { name: "Transportation", description: "Logistics, railroads, aviation, trucking" },
        { name: "Finance", description: "Banking, trading, insurance, fintech" },
        { name: "Technology", description: "Software, data centers, startups" }
      ]}
      metaDescription="Find the best PEOs in Chicago with The PEO App. Compare quotes from top Chicago Professional Employer Organizations offering specialized HR solutions for manufacturing, transportation, and finance industries."
      keyFeatures={[
        {
          icon: Building2,
          title: "Manufacturing Excellence",
          description: "Comprehensive HR solutions for Chicago's industrial sector with safety compliance and skilled workforce development."
        },
        {
          icon: Truck,
          title: "Transportation Hub Services",
          description: "Expert HR support for Chicago's transportation and logistics industry including DOT compliance and driver management."
        },
        {
          icon: Zap,
          title: "Union Relations Expertise",
          description: "Professional guidance for managing union relationships and collective bargaining in Chicago's labor-friendly environment."
        }
      ]}
    />
  );
};

export default ChicagoPage;
